import React, { useEffect } from 'react'
import { useState } from 'react'
import Modal from '../../../../common/modal'
import * as mdt from '../../../../common/modaltypes'
import { Box, Button, Divider, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Item } from '../../../../common/snippets'
import DropDownOA from '../../../../common/dropDownOA'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import Lineinput from '../../../../common/lineinput'

import { SelectChargeTypeOpt } from './PIckUpAndDropoffConstant'
import AddandRemoveBtn from './AddandRemoveBtn'
import { focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../../common/helper'
const PIckUpAndDropoffModal = ({ data, updateModal, updateAlertError, getPickupDropoffChargeSlab, updatePickUpAndDropOffCharge, generatePickUpAndDropOff }) => {
    const { loginData, isUpdate, headText, branchAndCityOpt } = data
    const [selSelectChrgType, setSelSelectChrgType] = useState(SelectChargeTypeOpt[0])
    const [showData, setShowData] = useState(false)
    const [branchOpt, setBranchOpt] = useState([]);
    const [cityOpt, setCityOpt] = useState([])
    const [selCity, setSelCity] = useState('')
    const [selBranch, setSelBranch] = useState('')
    const [pickupChrg, setPickupChrg] = useState([])
    const [dropOffChrg, setDropOffChrg] = useState([])
    const [pickupChrgKm, setPickupChrgKm] = useState([
      { fromKG: 1, toKG: 99999, fromKM: 1, toKm: 9999, fromPer: 0, toPer: 999999, rate: 0 },
    ])
    const [dropOffChrgKm, setDropOffChrgKm] = useState([
      { fromKG: 1, toKG: 99999, fromKM: 1, toKm: 9999, fromPer: 0, toPer: 999999, rate: 0 },
    ])
    const [isPickUpChrg, setIsPickUpChrg] = useState(false)
    const [isDropOffChrg, setIsDropOffChrg] = useState(false)
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    const tableHeader = [
        { headerName: "Range Min", headerSx: { minWidth: "25%", textAlign: 'right' } },
        { headerName: "Range Max", headerSx: { minWidth: "25%", textAlign: 'right' } },
        { headerName: "Rate", headerSx: { minWidth: "25%", textAlign: 'right' } },
        { headerName: "Action", headerSx: { minWidth: "25%", textAlign: 'left' } },
    ]
    const tableHeaderKM = [
        { headerName: "From KG - To KG", headerSx: { minWidth: "27%", textAlign: 'right' } },
        { headerName: "From KM - To KM", headerSx: { minWidth: "27%", textAlign: 'right' } },
        { headerName: "Rate Per KG-KM", headerSx: { minWidth: "25%", textAlign: 'right' } },
        { headerName: "Action", headerSx: { minWidth: "20%", textAlign: 'right' } },
    ];
    useEffect(() => {
        if (!isEmpty(loginData)) {
            let cityList = removeDuplicatesFromArray(branchAndCityOpt, "CityID")
            setCityOpt(cityList)
            let defaultCity = cityList.filter((val) => val.CityID === loginData?.intBranchCityID)
            if (defaultCity.length) {
                setSelCity(defaultCity[0])
                let branchList = removeDuplicatesFromArray(branchAndCityOpt, "BranchID");
                let cityWiseBranch = branchList.filter((val) => val.CityID === defaultCity[0]?.CityID)
                setBranchOpt(cityWiseBranch)
                let defaultBranch = cityWiseBranch.filter((val) => val.BranchID === loginData?.intBranchID)
                if (defaultBranch.length) {
                    setSelBranch(defaultBranch[0])
                } else {
                    setSelBranch(cityWiseBranch[0])
                }
            } else {
                setSelCity(cityList[0])
                let branchList = removeDuplicatesFromArray(branchAndCityOpt, "BranchID");
                let cityWiseBranch = branchList.filter((val) => val.CityID === cityList[0]?.CityID)
                setBranchOpt(cityWiseBranch)
                let defaultBranch = cityWiseBranch.filter((val) => val.BranchID === loginData?.intBranchID)
                if (defaultBranch.length) {
                    setSelBranch(defaultBranch[0])
                } else {
                    setSelBranch(cityWiseBranch[0])
                }
            }
        }
    }, [branchAndCityOpt, loginData])

    useEffect(() => {
        focusElemnt("Select_City")
    }, [])
    const handleIsPickUpChrg = (event) => {
        if (event.target.checked && pickupChrg.length === 0 && showData) {
            setPickupChrg([selSelectChrgType.id === 1 ? { RangeMin: 1, RangeMax: 99999, Charge: 0 } : { RangeMin: 1, RangeMax: 9999, Charge: 0 }])
        }
        setIsPickUpChrg(!isPickUpChrg)
    }
    const handleIsDropOffChrg = (event) => {
        if (event.target.checked && dropOffChrg.length === 0 && showData) {
            setDropOffChrg([selSelectChrgType.id === 1 ? { RangeMin: 1, RangeMax: 99999, Charge: 0 } : { RangeMin: 1, RangeMax: 9999, Charge: 0 }])
        }
        setIsDropOffChrg(!isDropOffChrg)
    }
    //PickUp charge
    const handlePickUpChrg = (event, field, index) => {
        if (field === 'RangeMax' && isUpdate && parseInt(event.target.value) > (selSelectChrgType.id === 1 ? 9999 : 99999)) {
            updateAlertError({ show: true, msg: `Range Max should not exceed ${selSelectChrgType.id === 1 ? 9999 : 99999}`, nextId: `pickUpRangeMax-${index}` })
            resetPickUpChrg(event, field, index)
        } else if (field === 'RangeMax' && isUpdate && event.target.value !== '' && (event.target.value !== '' ? parseInt(event.target.value) <= pickupChrg[index].RangeMin : true)) {
            updateAlertError({ show: true, msg: `Range Max should greater than Range Min`, nextId: `pickUpRangeMax-${index}` })
            resetPickUpChrg(event, field, index)
        } else if (field === 'RangeMin' && event.target.value !== '') {
            if (parseInt(event.target.value) <= pickupChrg[index - 1].RangeMin) {
                updateAlertError({ show: true, msg: `Value must be greater than previous value`, nextId: `pickUpRangeMin-${index}` })
                resetPickUpChrg(event, field, index)
            } else if ((pickupChrg.length - 1) > index ? pickupChrg[index + 1]?.RangeMin !== "" ? parseInt(event.target.value) >= pickupChrg[index + 1]?.RangeMin : false : false) {
                updateAlertError({ show: true, msg: `Value must be less than next value`, nextId: `pickUpRangeMin-${index}` })
                resetPickUpChrg(event, field, index)
            } else if (parseInt(event.target.value) >= (selSelectChrgType.id === 1 ? 9999 : 99999)) {
                updateAlertError({ show: true, msg: `Range Min should not exceed ${selSelectChrgType.id === 1 ? 9999 : 99999}`, nextId: `pickUpRangeMin-${index}` })
                resetPickUpChrg(event, field, index)
            } else if (isUpdate && (index === 3 && pickupChrg[index].RangeMax !== "" ? parseInt(event.target.value) > pickupChrg[index].RangeMax : false)) {
                updateAlertError({ show: true, msg: `Value must be less than Range Max`, nextId: `pickUpRangeMin-${index}` })
                resetPickUpChrg(event, field, index)
            }
        }
    }
    const resetPickUpChrg = (event, field, index) => {
        let oldData = [...pickupChrg.map((val, i) => i === index ? { ...val, [field]: "" } : val)];
        setPickupChrg(oldData)
        if (field === 'RangeMin') {
            oldData[index - 1].RangeMax = ""
        }
        setPickupChrg(oldData)
    }
    const handleChangePickUpChrg = (event, field, index) => {
        const regex = new RegExp('^[0-9\""]*$');
        if (regex.test(event.target.value)) {
            let oldData = [...pickupChrg.map((val, i) => i === index ? { ...val, [field]: event.target.value !== "" ? parseInt(event.target.value) : event.target.value } : val)];
            if (field === 'RangeMin') {
                oldData[index - 1].RangeMax = event.target.value !== "" ? event.target.value - 1 : event.target.value
            }
            setPickupChrg(oldData)
        }
    }
    const handleAddPickUpChrg = (index) => {
        let newData = { RangeMin: '', RangeMax: pickupChrg[index].RangeMax, Charge: 0 };
        let newArr = [...pickupChrg.map((val, i) => i === index ? { ...val, "RangeMax": "" } : val)]
        newArr.splice(index + 1, 0, newData)
        setPickupChrg(newArr)
    }
    const handleRemovePickUpChrg = (index) => {
        let oldRangeMax = pickupChrg[index].RangeMax
        let newData = pickupChrg.filter((val, i) => i !== index)
        setPickupChrg([...newData.map((val, i) => (i === (index - 1)) ? { ...val, 'RangeMax': oldRangeMax } : val)])
    }
    //DropOff charge
    const handleDropOffChrg = (event, field, index) => {
        if (field === 'RangeMax' && isUpdate && parseInt(event.target.value) > (selSelectChrgType.id === 1 ? 9999 : 99999)) {
            updateAlertError({ show: true, msg: `Range Max should not exceed ${selSelectChrgType.id === 1 ? 9999 : 99999}`, nextId: `dropOffMax-${index}` })
            resetDropOffChrg(event, field, index)
        } else if (field === 'RangeMax' && isUpdate && event.target.value !== '' && (event.target.value !== '' ? parseInt(event.target.value) <= dropOffChrg[index].RangeMin : true)) {
            updateAlertError({ show: true, msg: `Range Max should greater than Range Min`, nextId: `dropOffMax-${index}` })
            resetDropOffChrg(event, field, index)
        } else if (field === 'RangeMin' && event.target.value !== '') {
            if (parseInt(event.target.value) <= dropOffChrg[index - 1].RangeMin) {
                updateAlertError({ show: true, msg: `Value must be greater than previous value`, nextId: `dropOffMin-${index}` })
                resetDropOffChrg(event, field, index)
            } else if ((dropOffChrg.length - 1) > index ? dropOffChrg[index + 1]?.RangeMin !== "" ? parseInt(event.target.value) >= dropOffChrg[index + 1]?.RangeMin : false : false) {
                updateAlertError({ show: true, msg: `Value must be less than next value`, nextId: `dropOffMin-${index}` })
                resetDropOffChrg(event, field, index)
            } else if (parseInt(event.target.value) >= (selSelectChrgType.id === 1 ? 9999 : 99999)) {
                updateAlertError({ show: true, msg: `Range Min should not exceed ${selSelectChrgType.id === 1 ? 9999 : 99999}`, nextId: `dropOffMin-${index}` })
                resetDropOffChrg(event, field, index)
            } else if (isUpdate && (index === 3 && dropOffChrg[index].RangeMax !== "" ? parseInt(event.target.value) > dropOffChrg[index].RangeMax : false)) {
                updateAlertError({ show: true, msg: `Value must be less than Range Max`, nextId: `dropOffMin-${index}` })
                resetDropOffChrg(event, field, index)
            }
        }
    }
    const handleChangeDropOffChrg = (event, field, index) => {
        const regex = new RegExp('^[0-9\""]*$');
        if (regex.test(event.target.value)) {
            let oldData = [...dropOffChrg.map((val, i) => i === index ? { ...val, [field]: event.target.value !== "" ? parseInt(event.target.value) : event.target.value } : val)];
            if (field === 'RangeMin') {
                oldData[index - 1].RangeMax = event.target.value !== "" ? event.target.value - 1 : event.target.value
            }
            setDropOffChrg(oldData)
        }
    }
    const resetDropOffChrg = (event, field, index) => {
        let oldData = [...dropOffChrg.map((val, i) => i === index ? { ...val, [field]: "" } : val)];
        if (field === 'RangeMin') {
            oldData[index - 1].RangeMax = ""
        }
        setDropOffChrg(oldData)
    }

    const handleAddDropOffChrg = (index) => {
        let newData = { RangeMin: '', RangeMax: dropOffChrg[index].RangeMax, Charge: 0 };
        let newArr = [...dropOffChrg.map((val, i) => i === index ? { ...val, "RangeMax": "" } : val)]
        newArr.splice(index + 1, 0, newData)
        setDropOffChrg(newArr)
    }
    const handleRemoveDropOffChrg = (index) => {
        let oldRangeMax = dropOffChrg[index].RangeMax
        let newData = dropOffChrg.filter((val, i) => i !== index)
        setDropOffChrg([...newData.map((val, i) => (i === (index - 1)) ? { ...val, 'RangeMax': oldRangeMax } : val)])
    }
    //PickUp charge for KG-KM
    const handlePickupChrgKm = (event, field, index) => {
        let oldData = [...pickupChrgKm.map((val, i) => i === index ? { ...val, [field]: event.target.value } : val)];
        if (field === 'fromKG') {
            oldData[index - 1].toKG = event.target.value - 1
        }
        if (field === 'fromKM') {
            oldData[index - 1].toKm = event.target.value - 1
        }
        setPickupChrgKm(oldData)
    }
    const handleAddPickUpChrgKm = (index) => {
        let newRowData = { fromKG: "", toKG: pickupChrgKm[index].toKG, fromKM: "", toKm: pickupChrgKm[index].toKm, rate: 0 }
        let newArr = [...pickupChrgKm.map((val, i) => i === index ? { ...val, "toKG": "", "toKm": "" } : val)]
        newArr.splice(index + 1, 0, newRowData)
        setPickupChrgKm(newArr)
    }
    const handleRemovePickUpChrgKm = (index) => {
        let oldToKG = pickupChrgKm[index].toKG
        let oldToKm = pickupChrgKm[index].toKm
        let newData = pickupChrgKm.filter((val, i) => i !== index)
        setPickupChrgKm([...newData.map((val, i) => (i === (index - 1)) ? { ...val, 'toKG': oldToKG, toKm: oldToKm } : val)])
    }

    //DropOff charge for KG-KM
    const handleDropOffChrgKm = (event, field, index) => {
        let oldData = [...dropOffChrgKm.map((val, i) => i === index ? { ...val, [field]: event.target.value } : val)];
        if (field === 'fromKG') {
            oldData[index - 1].toKG = event.target.value - 1
        }
        if (field === 'fromKM') {
            oldData[index - 1].toKm = event.target.value - 1
        }
        setDropOffChrgKm(oldData)
    }
    const handleAddDropOffChrgKm = (index) => {
        let newRowData = { fromKG: "", toKG: dropOffChrgKm[index].toKG, fromKM: "", toKm: dropOffChrgKm[index].toKm, rate: 0 }
        let newArr = [...dropOffChrgKm.map((val, i) => i === index ? { ...val, "toKG": "", "toKm": "" } : val)]
        newArr.splice(index + 1, 0, newRowData)
        setDropOffChrgKm(newArr)
    }
    const handleRemoveDropOffChrgKm = (index) => {
        let oldToKG = dropOffChrgKm[index].toKG
        let oldToKm = dropOffChrgKm[index].toKm
        let newData = dropOffChrgKm.filter((val, i) => i !== index)
        setDropOffChrgKm([...newData.map((val, i) => (i === (index - 1)) ? { ...val, 'toKG': oldToKG, toKm: oldToKm } : val)])
    }
    const hasEmptyValue = (array, properties) => {
        return array.some(obj => {
            return properties.some(prop => {
                const value = obj[prop];
                return value === '' || value == null;
            });
        });
    };
    const disableBtn = () => {
        return (isPickUpChrg ? hasEmptyValue(pickupChrg, ["RangeMin", "RangeMax", "Charge"]) : false) || (isDropOffChrg ? hasEmptyValue(dropOffChrg, ["RangeMin", "RangeMax", "Charge"]) : false)
    }
    const resetPickAndDrop = (id) => {
        setShowData(false)
        setIsPickUpChrg(false)
        setIsDropOffChrg(false)
        if (id === 1) {
            setPickupChrg([])
            setDropOffChrg([])
        } else {
            setPickupChrg([])
            setDropOffChrg([])
        }
    }
    const handleChrgType = (value) => {
        setSelSelectChrgType(value)
        resetPickAndDrop(value.id)
    }
    const getPickupDropoffChargeValue = () => {
        const body = {
            CompanyID: loginData?.intCompanyID,
            BranchID: selBranch?.BranchID,
            ChargeTypeID: selSelectChrgType.id
        }
        resetPickAndDrop(selSelectChrgType.id)
        getPickupDropoffChargeSlab(body).then((res) => {
            if (res.status === 'Success') {
                if (!isUpdate && (res.Data.Table.length > 0 || res.Data.Table1.length > 0 || res.Data.Table2.length > 0)) {
                    updateAlertError({ show: true, msg: "Pickup/Dropoff Charge already updated for Selected Branch.", nextId: 'Select_City' })
                } else {
                    setShowData(true)
                    if (res.Data.Table.length) {
                        setIsPickUpChrg(res.Data.Table[0]?.IsPickupChargeEnabled === 1 ? true : false)
                        setIsDropOffChrg(res.Data.Table[0]?.IsDropoffChargeEnabled === 1 ? true : false)
                    }
                    if (res.Data.Table1.length) {
                        setPickupChrg(res.Data.Table1)
                    }
                    if (res.Data.Table2.length) {
                        setDropOffChrg(res.Data.Table2)
                    }
                    if(selSelectChrgType.id === 4 && !res.Data.Table2.length&& !res.Data.Table1.length){
                        const dummy = {Charge:0,RangeMin:1,RangeMax:999999}
                        setPickupChrg([dummy])
                        setDropOffChrg([dummy])
                    }
                }
            } else {
                updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'Select_City' })
            }
        }).catch((err) => {
            console.log('Error:', err)
        })
    }
    const saveAndUpdateCharg = () => {
        const body = {
            CompanyID: loginData?.intCompanyID,
            BranchID: selBranch?.BranchID,
            UserID: loginData?.intUserID,
            ChargeType: selSelectChrgType.id,
            IsPickupCharge: isPickUpChrg ? 1 : 0,
            IsDropOffCharge: isDropOffChrg ? 1 : 0,
            PickupchgQty: pickupChrg.map((val) => `${val.RangeMin}-${val.RangeMax}`).join(','),
            PickupCharges: pickupChrg.map((val) => val.Charge).join(','),
            DropoffchgQty: dropOffChrg.map((val) => `${val.RangeMin}-${val.RangeMax}`).join(','),
            DropoffCharges: dropOffChrg.map((val) => val.Charge).join(',')
        }
        updatePickUpAndDropOffCharge(body).then((res) => {
            if (res.status === 'Success') {
                generatePickUpAndDropOff()
                updateModal(false, isUpdate ? mdt.UpdatePickupAndDropoffModal : mdt.PickupAndDropoffModal)
                updateModal(true, mdt.pickupAndDropOffConfModal)
            } else {
                updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }
    return (
        <Modal
            headTxt={headText}
            width={selSelectChrgType?.id !== 3 ? '80%' : '90%'}
            updateModal={updateModal}
            closeId={"closeButton"}
            modalClass={'booking-popup'}
            modalStyle={modalStyle}

        >
            <Grid container sx={{ display: 'flex', padding: '12px 8px 4px 8px' }}>
                <Grid item md={3.6}>
                    <Item>
                        <DropDownOA
                            id={"Select_City"}
                            label={"Select City"}
                            width="100%"
                            prevId={'saveAndUpdateBtn'}
                            nextId={'Select_Branch'}
                            defaultvalue={selCity?.CityName || selCity}
                            data={cityOpt || []}
                            idKey={`CityID`}
                            dataKey={`CityName`}
                            onSelect={(val) => {
                                setSelCity(val)
                                resetPickAndDrop(selSelectChrgType.id)
                                let branchList = removeDuplicatesFromArray(branchAndCityOpt, "BranchID").filter((obj) => obj.CityID === val.CityID)
                                setBranchOpt(branchList)
                                setSelBranch(branchList[0])
                            }}
                        />
                    </Item>
                </Grid>
                <Grid item md={3.6} >
                    <Item>
                        <DropDownOA
                            id={"Select_Branch"}
                            label={"Select Branch"}
                            width="100%"
                            prevId={'Select_City'}
                            nextId={"Select_Charge_Type"}
                            defaultvalue={selBranch?.BranchName || selBranch}
                            data={branchOpt || []}
                            idKey={`BranchID`}
                            dataKey={`BranchName`}
                            onSelect={(val) => {
                                setSelBranch(val)
                                resetPickAndDrop(selSelectChrgType.id)
                            }}
                        />
                    </Item>
                </Grid>
                <Grid item md={3.6} >
                    <Item>
                        <DropDownOA
                            id={"Select_Charge_Type"}
                            data={SelectChargeTypeOpt || []}
                            defaultvalue={selSelectChrgType.name || selSelectChrgType}
                            label={"Select Charge Type"}
                            width="100%"
                            idKey={`id`}
                            onSelect={(val) => handleChrgType(val)}
                            dataKey={`name`}
                            prevId={'Select_Branch'}
                            nextId={"go_btn"}
                        />
                    </Item>
                </Grid>
                <Grid item md={1.1} sx={{ paddingY: '6px' }} >
                    <Item sx={{ ...sx.itemsx }} className="disabled-wrapper">
                        <Button variant="contained" id={'go_btn'}
                            style={{ ...sx.fullHeight, ...sx.novp, width: '100%' }}
                            onKeyDown={(e) => {
                                navigation3(e, "pickupCharge", "Select_Charge_Type", () => { })
                            }}
                            className="btn btn-primary"
                            onClick={() => getPickupDropoffChargeValue()}
                        >

                            GO
                        </Button>
                    </Item>
                </Grid>
            </Grid>
            <Grid container sx={{ paddingX: '15px', marginBottom: '10px' }}>
                <Grid item sm={12} md={6} sx={{ paddingRight: "8px" }}>
                    <Box >
                        <FormControlLabel control={<Checkbox id={"pickupCharge"} size={'medium'} checked={isPickUpChrg} />}
                            label={
                                <Typography variant='h6' sx={{ fontWeight: '600', color: "#444", fontSize: '16px' }}>
                                    Pickup Charge
                                </Typography>
                            }
                            onChange={handleIsPickUpChrg}
                            onKeyDown={(e) => {
                                navigation3(e, "dropOffCharge", "go_btn", () => { })
                            }}
                        />
                    </Box>
                    <TableContainer component={Paper} className='scroll' sx={{ marginY: "5px" }}>
                        {selSelectChrgType?.id !== 3 ?
                            <Table stickyHeader size="small" aria-label="a dense table"
                                sx={{
                                    '& .MuiTableCell-root': {
                                        padding: '6px 4px !important'
                                    }
                                }}
                            >
                                <TableHead>
                                    <TableRow>
                                        {tableHeader.map((row, index) => {
                                            return (
                                                <TableCell sx={{ ...row.headerSx, backgroundColor: '#DAEDFE', minHeight: '36px', fontSize: '12px', fontWeight: '600', color: '#444' }}>
                                                    {row.headerName}
                                                </TableCell>
                                            )
                                        })}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {isPickUpChrg ? pickupChrg.map((row, index) => {
                                        return (
                                            <TableRow >
                                                <TableCell>
                                                    <div className={'input--wrapper btmSpaceNotRequired'}>
                                                        <Lineinput
                                                            label={""}
                                                            id={`pickUpRangeMin-${index}`}
                                                            disabled={index === 0}
                                                            textAlign={'end'}
                                                            value={row.RangeMin}
                                                            onChange={(e) => handleChangePickUpChrg(e, "RangeMin", index)}
                                                            onBlur={(e) => handlePickUpChrg(e, "RangeMin", index)}
                                                            onKeyDown={(e) => {
                                                                navigation3(e, isUpdate && index === 3 ? `pickUpRangeMax-${index}` : `pickUpRate-${index}`, pickupChrg.length >= 4 ? `pickUpRate-${index - 1}` : `addbtn-${index - 1}`, () => { })
                                                            }}
                                                        />
                                                    </div>
                                                </TableCell>
                                                <TableCell>
                                                    <div className={'input--wrapper btmSpaceNotRequired'}>
                                                        <Lineinput
                                                            label={""}
                                                            id={`pickUpRangeMax-${index}`}
                                                            textAlign={'end'}
                                                            disabled={isUpdate && index === 3 ? false : true}
                                                            onChange={(e) => handleChangePickUpChrg(e, "RangeMax", index)}
                                                            onBlur={(e) => handlePickUpChrg(e, "RangeMax", index)}
                                                            onKeyDown={(e) => {
                                                                navigation3(e, `pickUpRate-${index}`, `pickUpRangeMin-${index}`, () => { })
                                                            }}
                                                            value={row.RangeMax}
                                                        />
                                                    </div>
                                                </TableCell>
                                                <TableCell>
                                                    <div className={'input--wrapper btmSpaceNotRequired'}>
                                                        <Lineinput
                                                            label={""}
                                                            id={`pickUpRate-${index}`}
                                                            textAlign={'end'}
                                                            value={row.Charge}
                                                            onChange={(e) => handleChangePickUpChrg(e, "Charge", index)}
                                                            onBlur={(e) => handlePickUpChrg(e, "Charge", index)}
                                                            onKeyDown={(e) => {
                                                                navigation3(e, pickupChrg.length >= 4 ? index === 3 ? `removebtn-${index}` : `pickUpRangeMin-${index + 1}` : `addbtn-${index}`, index === 0 ? "dropOffCharge" : isUpdate && index === 3 ? `pickUpRangeMax-${index}` : `pickUpRangeMin-${index}`)
                                                            }}
                                                        />
                                                    </div>
                                                </TableCell>
                                                <TableCell>
                                                    <AddandRemoveBtn pickUpChrg={true} addRow={handleAddPickUpChrg} removeRow={handleRemovePickUpChrg}
                                                        index={index} data={pickupChrg}
                                                        onKeyDownadd={(e) => {
                                                            navigation3(e, pickupChrg.length === 1 ? isDropOffChrg ? `dropOffRate-0` : "saveAndUpdateBtn" : pickupChrg.length - 1 === index ? `removebtn-${index}` : `pickUpRangeMin-${index + 1}`, `pickUpRate-${index}`, () => {
                                                                if (index === 2) {
                                                                    handleAddPickUpChrg(index)
                                                                    focusElemnt(`pickUpRate-${index}`)
                                                                }
                                                            })
                                                        }}
                                                        onKeyDownRemove={(e) => {
                                                            navigation3(e, isDropOffChrg ? "dropOffRate-0" : "saveAndUpdateBtn", pickupChrg.length >= 4 ? `pickUpRate-${index}` : `addbtn-${index}`, () => {
                                                                if (pickupChrg.length - 1 === index) {
                                                                    handleRemovePickUpChrg(index)
                                                                    focusElemnt(`pickUpRate-${index - 1}`)
                                                                }
                                                            })
                                                        }}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }) :
                                        <TableRow>
                                            <TableCell colSpan={4} align='center' sx={{ color: '#FE5200', minHeight: '36px', fontSize: '12px', fontWeight: '600' }}>No Result Found</TableCell>
                                        </TableRow>
                                    }
                                </TableBody>
                            </Table>
                            :
                            <Table stickyHeader size="small" aria-label="a dense table" sx={{
                                '& .MuiTableCell-root': {
                                    padding: '6px 4px !important'
                                }
                            }}>
                                <TableHead>
                                    <TableRow>
                                        {tableHeaderKM.map((row, index) => {
                                            return (
                                                <TableCell sx={{ ...row.headerSx, backgroundColor: '#DAEDFE', whiteSpace: 'nowrap', minHeight: '36px', fontSize: '12px', fontWeight: '600', color: '#444' }}>
                                                    {row.headerName}
                                                </TableCell>
                                            )
                                        })}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {isPickUpChrg ? pickupChrgKm.map((row, index) => {
                                        return (
                                            <TableRow >
                                                <TableCell>
                                                    <Box sx={{ display: 'flex' }}>
                                                        <div style={{ paddingRight: '4px' }} className={'input--wrapper btmSpaceNotRequired'}>
                                                            <Lineinput
                                                                label={""}
                                                                value={row.fromKG}
                                                                disabled={index === 0}
                                                                onBlur={(e) => handlePickupChrgKm(e, "fromKG", index)}
                                                            />
                                                        </div>
                                                        <div style={{ paddingLeft: '4px' }} className={'input--wrapper btmSpaceNotRequired'}>
                                                            <Lineinput
                                                                label={""}
                                                                value={row.toKG}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                    </Box>
                                                </TableCell>
                                                <TableCell>
                                                    <Box sx={{ display: 'flex' }}>
                                                        <div style={{ paddingRight: '4px' }} className={'input--wrapper btmSpaceNotRequired'}>
                                                            <Lineinput
                                                                label={""}
                                                                value={row.fromKM}
                                                                disabled={index === 0}
                                                                onBlur={(e) => handlePickupChrgKm(e, "fromKM", index)}
                                                            />
                                                        </div>
                                                        <div style={{ paddingLeft: '4px' }} className={'input--wrapper btmSpaceNotRequired'}>
                                                            <Lineinput
                                                                label={""}
                                                                value={row.toKm}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                    </Box>
                                                </TableCell>
                                                <TableCell>
                                                    <div className={'input--wrapper btmSpaceNotRequired'}>
                                                        <Lineinput
                                                            label={""}
                                                            value={row.rate}
                                                            onBlur={(e) => handlePickupChrgKm(e, "rate", index)}
                                                        />
                                                    </div>
                                                </TableCell>
                                                <TableCell>
                                                    <AddandRemoveBtn addRow={handleAddPickUpChrgKm} removeRow={handleRemovePickUpChrgKm} index={index} data={pickupChrgKm} />
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                                        :
                                        <TableRow>
                                            <TableCell colSpan={4} align='center' sx={{ color: '#FE5200', minHeight: '36px', fontSize: '12px', fontWeight: '600' }}>No Result Found</TableCell>
                                        </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        }
                    </TableContainer>
                </Grid>
                <Grid item sm={12} md={6} sx={{ paddingLeft: "8px" }}>
                    <Box >
                        <FormControlLabel control={<Checkbox id="dropOffCharge" size={'medium'} checked={isDropOffChrg} />}
                            label={
                                <Typography variant='h6' sx={{ fontWeight: '600', color: "#444", fontSize: '16px' }}>
                                    Drop Off Charge
                                </Typography>
                            }
                            onChange={handleIsDropOffChrg}
                            onKeyDown={(e) => {
                                navigation3(e, (isDropOffChrg || isPickUpChrg) ? isPickUpChrg ? "pickUpRate-0" : isDropOffChrg ? `dropOffMin-0` : "saveAndUpdateBtn" : "saveAndUpdateBtn", "pickupCharge", () => { })
                            }}
                        />
                    </Box>
                    <TableContainer component={Paper} className='scroll' sx={{ marginY: "5px" }}>
                        {selSelectChrgType?.id !== 3 ?
                            <Table stickyHeader size="small" aria-label="a dense table" sx={{
                                '& .MuiTableCell-root': {
                                    padding: '6px 4px !important'
                                }
                            }}>
                                <TableHead>
                                    <TableRow>
                                        {tableHeader.map((row, index) => {
                                            return (
                                                <TableCell sx={{ ...row.headerSx, backgroundColor: '#DAEDFE', minHeight: '36px', fontSize: '12px', fontWeight: '600', color: '#444' }}>
                                                    {row.headerName}
                                                </TableCell>
                                            )
                                        })}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {isDropOffChrg ? dropOffChrg.map((row, index) => {
                                        return (
                                            <TableRow >
                                                <TableCell>
                                                    <div className={'input--wrapper btmSpaceNotRequired'}>
                                                        <Lineinput
                                                            label={""}
                                                            disabled={index === 0}
                                                            id={`dropOffMin-${index}`}
                                                            textAlign={'end'}
                                                            value={row.RangeMin}
                                                            onChange={(e) => handleChangeDropOffChrg(e, "RangeMin", index)}
                                                            onBlur={(e) => handleDropOffChrg(e, "RangeMin", index)}
                                                            onKeyDown={(e) => {
                                                                navigation3(e, isUpdate && index === 3 ? `dropOffMax-${index}` : `dropOffRate-${index}`, dropOffChrg.length >= 4 ? `dropOffRate-${index - 1}` : `addbtnD-${index - 1}`, () => { })
                                                            }}

                                                        />
                                                    </div>
                                                </TableCell>
                                                <TableCell>
                                                    <div className={'input--wrapper btmSpaceNotRequired'}>
                                                        <Lineinput
                                                            label={""}
                                                            id={`dropOffMax-${index}`}
                                                            textAlign={'end'}
                                                            disabled={isUpdate && index === 3 ? false : true}
                                                            value={row.RangeMax}
                                                            onChange={(e) => handleChangeDropOffChrg(e, "RangeMax", index)}
                                                            onBlur={(e) => handleDropOffChrg(e, "RangeMax", index)}
                                                            onKeyDown={(e) => {
                                                                navigation3(e, `dropOffRate-${index}`, `dropOffMin-${index}`, () => { })
                                                            }}
                                                        />
                                                    </div>
                                                </TableCell>
                                                <TableCell>
                                                    <div className={'input--wrapper btmSpaceNotRequired'}>
                                                        <Lineinput
                                                            label={""}
                                                            value={row.Charge}
                                                            id={`dropOffRate-${index}`}
                                                            textAlign={'end'}
                                                            onChange={(e) => handleChangeDropOffChrg(e, "Charge", index)}
                                                            onBlur={(e) => handleDropOffChrg(e, "Charge", index)}
                                                            onKeyDown={(e) => {
                                                                navigation3(e, dropOffChrg.length >= 4 ? index === 3 ? `removebtnW-${index}` : `dropOffMin-${index + 1}` : `addbtnD-${index}`, index === 0 ? isPickUpChrg ? dropOffChrg.length === 1 ? `addbtn-${dropOffChrg.length - 1}` : `removebtn-${pickupChrg.length - 1}` : "dropOffCharge" : isUpdate && index === 3 ? `dropOffMax-${index}` : `dropOffMin-${index}`, () => { })
                                                            }}
                                                        />
                                                    </div>
                                                </TableCell>
                                                <TableCell>
                                                    <AddandRemoveBtn addRow={handleAddDropOffChrg} removeRow={handleRemoveDropOffChrg} index={index} data={dropOffChrg}
                                                        onKeyDownadd={(e) => {
                                                            navigation3(e, dropOffChrg.length === 1 ? "saveAndUpdateBtn" : dropOffChrg.length - 1 === index ? `removebtnW-${index}` : `dropOffMin-${index + 1}`, `dropOffRate-${index}`, () => { })
                                                            if (index === 2) {
                                                                handleAddDropOffChrg(index)
                                                                focusElemnt(`dropOffRate-${index}`)
                                                            }
                                                        }}
                                                        onKeyDownRemove={(e) => {
                                                            navigation3(e, "saveAndUpdateBtn", dropOffChrg.length >= 4 ? `dropOffRate-${index}` : `addbtnD-${index}`, () => {
                                                                if (dropOffChrg.length - 1 === index) {
                                                                    handleRemoveDropOffChrg(index)
                                                                    focusElemnt(`dropOffRate-${index - 1}`)
                                                                }
                                                            })
                                                        }}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                                        :
                                        <TableRow>
                                            <TableCell colSpan={4} align='center' sx={{ color: '#FE5200', minHeight: '36px', fontSize: '12px', fontWeight: '600' }}>No Result Found</TableCell>
                                        </TableRow>
                                    }
                                </TableBody>
                            </Table>
                            :
                            <Table stickyHeader size="small" aria-label="a dense table" sx={{
                                '& .MuiTableCell-root': {
                                    padding: '6px 4px !important'
                                }
                            }}>
                                <TableHead>
                                    <TableRow>
                                        {tableHeaderKM.map((row, index) => {
                                            return (
                                                <TableCell sx={{ ...row.headerSx, backgroundColor: '#DAEDFE', whiteSpace: 'nowrap', minHeight: '36px', fontSize: '12px', fontWeight: '600', color: '#444' }}>
                                                    {row.headerName}
                                                </TableCell>
                                            )
                                        })}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {isDropOffChrg ? dropOffChrgKm.map((row, index) => {
                                        return (
                                            <TableRow >
                                                <TableCell>
                                                    <Box sx={{ display: 'flex' }}>
                                                        <div style={{ paddingRight: '4px' }} className={'input--wrapper btmSpaceNotRequired'}>
                                                            <Lineinput
                                                                label={""}
                                                                value={row.fromKG}
                                                                disabled={index === 0}
                                                                onBlur={(e) => handleDropOffChrgKm(e, "fromKG", index)}

                                                            />
                                                        </div>
                                                        <div style={{ paddingLeft: '4px' }} className={'input--wrapper btmSpaceNotRequired'}>
                                                            <Lineinput
                                                                label={""}
                                                                value={row.toKG}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                    </Box>
                                                </TableCell>
                                                <TableCell>
                                                    <Box sx={{ display: 'flex' }}>
                                                        <div style={{ paddingRight: '4px' }} className={'input--wrapper btmSpaceNotRequired'}>
                                                            <Lineinput
                                                                label={""}
                                                                value={row.fromKM}
                                                                disabled={index === 0}
                                                                onBlur={(e) => handleDropOffChrgKm(e, "fromKM", index)}

                                                            />
                                                        </div>
                                                        <div style={{ paddingLeft: '4px' }} className={'input--wrapper btmSpaceNotRequired'}>
                                                            <Lineinput
                                                                label={""}
                                                                value={row.toKm}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                    </Box>
                                                </TableCell>
                                                <TableCell>
                                                    <div className={'input--wrapper btmSpaceNotRequired'}>
                                                        <Lineinput
                                                            label={""}
                                                            value={row.rate}
                                                            onBlur={(e) => handleDropOffChrgKm(e, "rate", index)}
                                                        />
                                                    </div>
                                                </TableCell>
                                                <TableCell>
                                                    <AddandRemoveBtn addRow={handleAddDropOffChrgKm} removeRow={handleRemoveDropOffChrgKm} index={index} data={dropOffChrgKm} />
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                                        :
                                        <TableRow>
                                            <TableCell colSpan={4} align='center' sx={{ color: '#FE5200', minHeight: '36px', fontSize: '12px', fontWeight: '600' }}>No Result Found</TableCell>
                                        </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        }
                    </TableContainer>
                </Grid>
            </Grid>
            <Divider />
            <Grid container sx={{ paddingX: "10px" }}>
                <Grid item md={10} sx={{ display: 'flex' }}>
                    {selSelectChrgType.id === 3 && <>
                        <Item>
                            <FormControlLabel control={<Checkbox defaultChecked />}
                                label={
                                    <Typography variant='h6' sx={{ fontWeight: '600' }}>
                                        Additional Charge Per Unit
                                    </Typography>
                                }
                            />
                        </Item>
                        <Item className={'input--wrapper btmSpaceNotRequired'}>
                            <Lineinput
                                label={"Pickup"}
                            />
                        </Item>
                        <Item className={'input--wrapper btmSpaceNotRequired'}>
                            <Lineinput
                                label={"Dropoff"}
                            />
                        </Item>
                    </>
                    }
                </Grid>
                <Grid item md={2} sx={{ paddingRight: '6px', paddingY: '8px', display: 'flex', justifyContent: 'end' }} className="disabled-wrapper">
                    <Button variant="contained" id={"saveAndUpdateBtn"} disabled={disableBtn() || !showData} style={{ ...sx.fullHeight, ...sx.novp, height: '40px' }} className="btn btn-primary"
                        onKeyDown={(e) => {
                            navigation3(e, "Select_City", (isDropOffChrg || isPickUpChrg) ? "" : "dropOffCharge", () => { })
                        }}
                        onClick={saveAndUpdateCharg}
                    >
                        {isUpdate ? 'UPDATE' : 'SAVE'}
                    </Button>
                </Grid>
            </Grid>
        </Modal>
    )
}

export default PIckUpAndDropoffModal